import { AttributePopupWrapper } from "./AttributeModalWrapper.styles";
import React from "react";
import { inject, observer } from "mobx-react";
import { Row, Col } from "react-bootstrap";
// import { ReactSortable } from "react-sortablejs";
import ProductStore from "../ProductStore";
import AttributeStore from "../AttributeStore";
import {
  CustomLabel,
  FlexContainer,
  Input,
  IOption,
  ModalComponent,
  SapphireBlueButton,
  SingleSelect,
  CreatableSelect as SelectCreateable,
  ColorPicker as ColorPickerComponent,
  InputColorBlock,
} from "@mindmemobile/mm-shared-global";
import {
  ProductAttributeOptionsModel,
  ProductAttributesModel,
} from "../../../shared/models";
import { AttributeTypes, AttributeValueTypes } from "../../../shared/enums";
import DraggableIcon from "../../../../../../images/products/draggable-grey.svg";
import CloseIcon from "../../../../../../images/products/close.svg";
import SortablePlugin from "../../../shared/components/SortablePlugin";

type Props = {
  productStore?: ProductStore;
  onClose: () => void;
};
@inject("productStore")
@observer
export default class ProductSelectAttribute extends React.Component<Props> {
  private data: AttributeStore;

  constructor(props: Props) {
    super(props);

    this.data = new AttributeStore();

    if (
      this.props.productStore &&
      this.props.productStore?.editAttributeIndex > -1
    ) {
      const attribute =
        this.props.productStore?.selectedAttributes[
          this.props.productStore.editAttributeIndex
        ];
      this.data.updateState(new ProductAttributesModel({ ...attribute }));
    }
    this.data.addCustomAttributes(this.props.productStore?.selectedAttributes);
  }

  // onSelectOption(id: string) {
  //     const attributeData = this.props.productStore?.attributeData?.find((a) => a.id === id);

  //     if (attributeData) {
  //         const selected = toJS(this.props.productStore?.selectedAttributes) || [];
  //         const isExists = selected.findIndex((x) => x.id === id) > -1;

  //         if (!isExists) {
  //             selected.push(attributeData);
  //             this.props.productStore?.updateSelectedAttributes(selected);
  //             this.props.onClose();
  //         }
  //     }
  // }

  selectDropDown(
    hasError: boolean,
    options: any[],
    selectedKey: string,
    className: string,
    onChange: (value: string) => void,
    searchable = true
  ) {
    return (
      <SingleSelect
        selectedKey={selectedKey}
        hasError={hasError}
        nameKeys={["label"]}
        valueKeys={["value"]}
        options={[options]}
        searchable={searchable}
        onChange={(option: any) => {
          onChange(option.value);
        }}
        className={className}
      />
    );
  }

  get selectedCategories(): IOption[] {
    if (!this.data.attribute) return [];
    if (!this.data.attribute.name) return [];

    return [
      { value: this.data.attribute.name, label: this.data.attribute.name },
    ];
  }

  onCreateOrSelectCategory(newValue: IOption) {
    if (!newValue) {
      this.data.updateState(
        new ProductAttributesModel({
          ...this.data.attribute,
          attributeType: AttributeTypes.Custom,
          name: "",
        })
      );
      return;
    }
    if (newValue?.__isNew__) {
      this.data.addNewAttribute(newValue);
    }

    if (newValue?.__isNew__) {
      this.data.updateState(
        new ProductAttributesModel({
          ...this.data.attribute,
          attributeType: AttributeTypes.Custom,
          name: newValue?.label,
        })
      );
    } else {
      this.data.updateState(
        new ProductAttributesModel({
          ...this.data.attribute,
          attributeType: newValue.value as AttributeTypes,
          name: newValue?.label,
          valueType:
            newValue.value === AttributeTypes.Color
              ? AttributeValueTypes.Color
              : AttributeValueTypes.Text,
        })
      );
    }
  }

  creatableDropDown(hasError: boolean, options: IOption[], className: string) {
    return (
      <SelectCreateable
        className={className}
        isClearable={true}
        isMulti={false}
        error={hasError}
        options={options}
        selectedOptions={this.selectedCategories}
        onSingleChange={(newValue) => this.onCreateOrSelectCategory(newValue)}
        classPrefix="option-select"
        placeholder="Select or Type"
      />
    );
  }

  input(
    hasError: boolean,
    value: string,
    placeholder: string,
    onChange: (value: string) => void,
    className: string = ""
  ) {
    return (
      <Input
        type="text"
        error={hasError}
        onChange={(e) => onChange(e.target.value)}
        value={value}
        placeholder={placeholder}
        className={className}
        maxLength={100}
      />
    );
  }

  get getSelectOptions() {
    const attributes = this.props.productStore?.attributeData || [];
    const selectedAttributes =
      this.props.productStore?.selectedAttributes || [];
    const nonSelectedAttributes = attributes.filter(
      (a) => selectedAttributes.findIndex((s) => s.id === a.id) === -1
    );
    return (
      nonSelectedAttributes.map((a) => {
        return { value: a.id, label: a.name };
      }) || []
    );
  }

  get getAttributeTypes(): IOption[] {
    const predefinedOptions = Object.keys(AttributeTypes)
      .filter(
        (key) => AttributeTypes[key as keyof typeof AttributeTypes] !== "Custom"
      )
      .map((key: string) => {
        return {
          value: key,
          label: AttributeTypes[key as keyof typeof AttributeTypes],
        };
      });
    const customAttributes = this.data?.customAttributes || [];
    return [...predefinedOptions, ...customAttributes];
  }

  get getAttributeValueTypes(): any[] {
    return Object.keys(AttributeValueTypes).map((key: string) => {
      return {
        value: key,
        label: AttributeValueTypes[key as keyof typeof AttributeValueTypes],
      };
    });
  }

  get showColorBox() {
    return this.data.attribute.valueType === AttributeValueTypes.Color;
  }

  get renderOptions() {
    const { options } = this.data.attribute;
    const handleSortEnd = (sortedKeys: string[]) => {
      const sortedOptions = sortedKeys
        .map((key) => options.find((option) => option.referenceId === key))
        .filter(
          (option): option is ProductAttributeOptionsModel =>
            option !== undefined
        );
      this.data.updateState(
        new ProductAttributesModel({
          ...this.data.attribute,
          options: sortedOptions,
        })
      );
    };
    return (
      <Row>
        <Col md={3}>
          <CustomLabel lineHeight="40px"> Options</CustomLabel>
        </Col>
        <Col md={9}>
          {/* <ReactSortable
            list={options}
            setList={(sortedOptions) => {
              this.data.updateState(
                new ProductAttributesModel({
                  ...this.data.attribute,
                  options: sortedOptions,
                })
              );
            }}
            animation={150}
          > */}
          <SortablePlugin onSortEnd={handleSortEnd} animation={150}>
            {options.map((option, idx) => {
              return (
                <div key={option.referenceId} data-key={option.referenceId}>
                  <FlexContainer
                    spacing={15}
                    alignItems="center"
                    padding="0px 0px 15px 0px"
                  >
                    <img src={DraggableIcon} />
                    <div>
                      <FlexContainer className="color-outer-input">
                        {this.input(
                          option.hasError,
                          option.name,
                          " ",
                          (newValue) => {
                            this.data.onOptionTextChange(newValue, idx);
                          },
                          `custom-styled-input attribute-input ${this.showColorBox && "color-block-input"}`
                        )}

                        {this.showColorBox && (
                          <>
                            <InputColorBlock
                              bgColor={option.color?.rgba}
                              onClick={() => this.data.toggleColorPicker(idx)}
                            >
                              {/* <img src={DeleteIcon} className="colorBlock-trash-icon" /> */}
                            </InputColorBlock>
                            {option.showColorPicker && (
                              <ColorPickerComponent
                                color={option.deserializeColor()}
                                onChange={(color) => {
                                  this.data.onUpdateColor(color, idx);
                                }}
                                onHide={() => this.data.toggleColorPicker(idx)}
                                className="attribute-color-picker"
                              />
                            )}
                          </>
                        )}
                      </FlexContainer>
                    </div>
                    {idx > 0 && (
                      <img
                        src={CloseIcon}
                        onClick={() => this.data.deleteOption(idx)}
                        className="clickable"
                      />
                    )}
                  </FlexContainer>
                </div>
              );
            })}
          </SortablePlugin>
          {/* </ReactSortable> */}
          <CustomLabel
            color="#556BB8"
            lineHeight={options.length > 0 ? "22px" : "40px"}
            onClick={() => this.data.onAddOption()}
            margin="0px 0px 0px 33px"
            className="clickable"
          >
            Add Option
          </CustomLabel>
        </Col>
      </Row>
    );
  }

  onSubmit() {
    const success = this.data.validate();
    if (!success) return;

    this.props.productStore?.updateSelectedAttributes(
      new ProductAttributesModel({
        ...this.data.attribute,
      })
    );
    this.props.onClose();
  }

  get body() {
    return (
      <>
        <Row>
          <Col md={3}>
            <CustomLabel lineHeight="40px"> Attribute</CustomLabel>
          </Col>
          <Col md={9}>
            <FlexContainer spacing={15} className="">
              {this.creatableDropDown(
                this.data.attribute.hasError("name"),
                this.getAttributeTypes,
                "attribute-style"
              )}
              {this.selectDropDown(
                false,
                this.getAttributeValueTypes,
                this.data.attribute.valueType,
                "text-style",
                (newValue) =>
                  this.data.updateState(
                    new ProductAttributesModel({
                      ...this.data.attribute,
                      valueType: newValue as AttributeValueTypes,
                    })
                  ),
                false
              )}
            </FlexContainer>
          </Col>
        </Row>
        {this.renderOptions}
      </>
    );
  }
  render(): React.ReactNode {
    return (
      <AttributePopupWrapper>
        <ModalComponent
          title="Attribute"
          titleFontSize="22px"
          bodyPadding="50px 60px"
          onClose={() => this.props.onClose()}
          showFooter={true}
          minHeight="440px"
          wrapperWidth="720px"
          bodyBackgroundColor="#F4F7FB"
          footerHeight="auto"
          footerContent={
            <FlexContainer
              alignItems="center"
              justifyContent="center"
              spacing={15}
            >
              <SapphireBlueButton
                minWidth="120px"
                height="40px"
                onClick={() => this.props.onClose()}
              >
                Close
              </SapphireBlueButton>
              <SapphireBlueButton
                primary
                minWidth="120px"
                height="40px"
                onClick={() => this.onSubmit()}
              >
                Save
              </SapphireBlueButton>
            </FlexContainer>
          }
        >
          {this.body}
        </ModalComponent>
      </AttributePopupWrapper>
    );
  }
}
